import React from 'react';

import Button from '@/components/Buttons/Button';
import SubscriptionModals from '@/components/Modals/SubscriptionModals';
import { SubscriptionPlan } from '@/components/SubscriptionCard/SubscriptionCard.utils';
import { useCtaButton } from '@/components/SubscriptionCard/SubscriptionCardContent/useCtaButton';

export const CtaButton = ({
  plan,
  isCurrentPlan,
  id,
  verified
}: {
  plan: SubscriptionPlan;
  isCurrentPlan?: boolean;
  id: number;
  verified: boolean
}) => {
  const {
    buttonClassName,
    modalType,
    isModalOpen,
    currentPlanDetails,
    buttonText,
    handleButtonClick,
    handleCloseModal,
    handleOpenModal,
    
  } = useCtaButton({ plan, isCurrentPlan, id });

  return (
    <>
      <div className='bg-black border-none h-40px rounded-lg'>
        <Button
          onClick={handleButtonClick}
          className={`subscriptionCtaButton ${buttonClassName[plan]} border-none box-border flex items-center justify-center h-40px rounded-lg text-white text-16px duration-500 font-bold cursor-pointer`}
        >
          {buttonText}
        </Button>
      </div>

      {modalType && currentPlanDetails && verified && (
        <SubscriptionModals
          type={modalType}
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          handleOpenModal={handleOpenModal}
          selectedPlanPriceId={currentPlanDetails.foundCurrentPlanPriceId}
        />
      )}
    </>
  );
};
